import { render, staticRenderFns } from "./Resumes.vue?vue&type=template&id=94af7584&"
import script from "./Resumes.vue?vue&type=script&lang=js&"
export * from "./Resumes.vue?vue&type=script&lang=js&"
import style0 from "./Resumes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports